import { Component, Input, OnInit, inject, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BaseComponent } from '@wms/components';
import { LiveWidgetSettingsService } from '@wms/app/services/liveWidgetsSettings/live-widget-settings.service';
import { forEach, findIndex, filter } from 'lodash-es';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'wms-live-widgets-fields-list',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule],
  templateUrl: './live-widgets-fields-list.component.html',
  styleUrls: ['./live-widgets-fields-list.component.less'],
  host: { 'class': 'fields-list-container' }
})
export class LiveWidgetsFieldsListComponent extends BaseComponent implements OnInit {

  @Input() columnDef: any;
  @Input() id: any;
  @Input() index: any;
  @Output() updateSelectedComponent = new EventEmitter<any>();
  collapsed: boolean = false;
  liveWidgetSettingsService: LiveWidgetSettingsService;

  constructor() {
    super();
    this.liveWidgetSettingsService = inject(LiveWidgetSettingsService);
  }

  toggleGroup(scope: any, event: Event) {
    event.stopPropagation();
    scope.collapsed = !scope.collapsed;
  }

  /*function to check if select all should be selected*/
  updateSelectAll = (field: any, selectedOption: any, fieldDef?: any) => {
    let columnCount = 0,
      arrElementNotSelected: any = [],
      componentDef;
    if (field === 'field' && this.liveWidgetSettingsService.designerType === this.liveWidgetSettingsService.designerTypes.TABLE) {
      componentDef = this.liveWidgetSettingsService.headerConfig;
    } else {
      componentDef = this.liveWidgetSettingsService.componentDefnObject[field];
    }
    columnCount += this.liveWidgetSettingsService.getAllSelectedFields(componentDef, arrElementNotSelected, selectedOption);
    if (field === 'button' && this.liveWidgetSettingsService.designerType === this.liveWidgetSettingsService.designerTypes.TABLE) {
      arrElementNotSelected = arrElementNotSelected.concat(filter(this.liveWidgetSettingsService.componentDefnObject.rowActions, (value: any) => {
        columnCount++;
        return value[selectedOption] !== true;
      }));
    }
    this.liveWidgetSettingsService.setDeviceActionMessage(field);
    columnCount = columnCount + this.liveWidgetSettingsService.componentDefnObject.button.length;
    this.liveWidgetSettingsService.componentDefnObject.isSelectAll[field][selectedOption] = columnCount && !(arrElementNotSelected.length > 0);
    this.liveWidgetSettingsService.updateSaveDisabled();

    if (fieldDef) {
      if (this.liveWidgetSettingsService.selectedComponent[field].key === fieldDef.key) {
        this.liveWidgetSettingsService.selectedComponent[field][selectedOption] = fieldDef[selectedOption];
      }
    }
  }

  //Function to delete a group.On deleting a group, shift columns inside the group to parent
  deleteGroup(headerConfig: any, groupDef?: any, parent?: any) {
    let index = findIndex(headerConfig, { 'field': groupDef.field }),
      deletedGroup,
      isSelected = false;
    //If the deleted group is found, delete the group. Else, search in the inner nodes
    if (index > -1) {
      deletedGroup = headerConfig[index];
      if (deletedGroup && deletedGroup.columns.length) {
        headerConfig.splice(index, 1); //Delete the group
        forEach(deletedGroup.columns, (col: any, i: any) => {
          if (!isSelected) {
            //Select tje inner item form deleted group
            this.updateSelectedComponent.emit({ componentDef: col, componentType: 'field' });
            isSelected = true;
          }
          //If parent is found, push the columns to parent. Else, push the columns to root node.
          //Push the columns/ group at same level where the group is deleted
          if (parent && parent.columns) {
            parent.columns.splice(index + i, 0, col);
          } else {
            this.liveWidgetSettingsService.headerConfig.splice(index + i, 0, col);
            this.liveWidgetSettingsService.headerConfig = [...this.liveWidgetSettingsService.headerConfig];
          }
        });
      } else {
        //If columns are not present in the group, select the previous column/ group
        if (index > 0) {
          this.updateSelectedComponent.emit({ componentDef: headerConfig[index - 1], componentType: 'field' });
        } else {
          //If columns are not present in the group and delted group is first, select the next column/ group
          if (headerConfig[index + 1]) {
            this.updateSelectedComponent.emit({ componentDef: headerConfig[index + 1], componentType: 'field' });
          }
        }
        headerConfig.splice(index, 1); //Delete the group
      }
      return false;
    }
    forEach(headerConfig, (config: any) => {
      if (config.isGroup) {
        this.deleteGroup(config.columns, groupDef, config);
      }
    });
    return;
  }

  //Function to delete the field
  deleteField = (columnDef: any) => {
    columnDef.remove = !columnDef.remove;
    this.liveWidgetSettingsService.updateSaveDisabled();
  }

  handleClick = (event: Event) => {
    event.stopPropagation();
    event.preventDefault();
    this
  }

  ngOnInit(): void {
  }

}
